import { defineStore } from 'pinia';
import storageUtil from '@/utils/storage';

export const useThemeStore = defineStore('theme', {
  state: () => ({
    color: storageUtil.getItem('color') || '#EF6937',
  }),
  actions: {
    setColor(color) {
      this.color = color;
      storageUtil.setItem('color', color);
    }
  }
});
